export default __webpack_public_path__ + "static/media/iconMapPinBlack.5aca80d8.svg";